/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Filters_ClearInputs */

const es_feedback_filters_clear = /** @type {(inputs: Feedback_Filters_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar filtros`)
};

const en_feedback_filters_clear = /** @type {(inputs: Feedback_Filters_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Feedback_Filters_ClearInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_filters_clear = /** @type {((inputs?: Feedback_Filters_ClearInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Filters_ClearInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_filters_clear(inputs)
	return en_feedback_filters_clear(inputs)
});
export { feedback_filters_clear as "feedback.filters.clear" }